import { render, staticRenderFns } from "./CoverageForm.vue?vue&type=template&id=327f0a09&"
import script from "./CoverageForm.vue?vue&type=script&lang=js&"
export * from "./CoverageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports